module.exports = __webpack_public_path__ + "img/purchase-management.f4a4a9ec.svg";